import {
  DEFAULT_ANIMATION,
  parseAnimation,
  type AnimationConfig,
} from '@game-platform/pack-animation';
import { forgetOfferAnimations } from './offerOverrides';

// Memory only: the section arrives with design_system on every boot, well
// before a pack can be opened, so nothing has to survive a reload.
let current: AnimationConfig = DEFAULT_ANIMATION;
const listeners = new Set<() => void>();

function notify(): void {
  for (const cb of listeners) cb();
}

/** The operator's opening mechanic; the slot lane until design_system says otherwise. */
export function loadOpeningAnimation(): AnimationConfig {
  return current;
}

/** Accepts the raw `design_system.animation` section or an already parsed config. */
export function saveOpeningAnimation(raw: unknown): void {
  const next = parseAnimation(raw);
  if (JSON.stringify(next) === JSON.stringify(current)) return;
  current = next;
  notify();
}

/** Back to boot: the slot lane, and no pack seen yet. */
export function clearOpeningAnimation(): void {
  saveOpeningAnimation(undefined);
  forgetOfferAnimations();
}

export function subscribe(cb: () => void): () => void {
  listeners.add(cb);
  return () => {
    listeners.delete(cb);
  };
}
